import BootstrapDialog from 'bootstrap4-dialog';
import 'jquery-validation/dist/jquery.validate.js';
import EditableDataContainer from '@appPath/entities/editables/editable-data-container.js';

var jsUtils = (function () {
    // To access methods from another module from inside this class use: _methods
    //TODO DPH Refactor: Separate into modules
    (function setBootrapDialogDefaults() {
        BootstrapDialog.configDefaultOptions({
            spinicon: 'fal fa-refresh'
        });
    })();
    var editableInitPendingList = [];
    var bootstrapDialog = {
        confirmDialog: function (title, message, cancelButtonLabel, confirmButtonLabel, functionToRunOnConfirm, isCallbackAnyc, functionToRunOnCancel, additionalDialogOptions) { //TODO DPH: Default Cancel/Confirm labels
            var options = $.extend(true, getDefaultOptions(), additionalDialogOptions ? additionalDialogOptions : {});

            if (options.type == BootstrapDialog.TYPE_WARNING) {
                options.buttons[0].cssClass = 'btn-secondary'; // cancel
                options.buttons[1].cssClass = 'btn-danger'; // confirm
            }

            var dialog = new BootstrapDialog(options);
            dialog.realize();

            var $body = dialog.getModalBody();

            $body.find('form').on('submit', function (e) {
                e.preventDefault();
                var $button = dialog.getButton('confirm-dialog-button');

                if (_methods.form.hasAttribute($button, 'disabled') == false) {
                    $button.trigger('click');
                }
            });

            dialog.open();

            function getDefaultOptions() {
                return {
                    //autodestroy:false,
                    title: title,
                    message: message,
                    draggable: true,
                    closeByBackdrop: false,
                    buttons: [{
                        id: 'cancel-dialog-button',
                        label: cancelButtonLabel,
                        action: function (me) {
                            if (functionToRunOnCancel) {
                                functionToRunOnCancel();
                            }

                            me.close();
                        },
                    }, {
                        id: 'confirm-dialog-button',
                        label: confirmButtonLabel,
                        cssClass: 'btn-success',
                        action: function (me) {
                            // preventDefault();
                            var $button = this;
                            $button.disable();

                            if (isCallbackAnyc == true) {
                                functionToRunOnConfirm().done(function () {
                                    me.close();
                                });
                            } else {
                                functionToRunOnConfirm();
                                me.close();
                            }
                        },
                    },]
                };
            }
        },
        showWaitDialog: function (title, message, enableCloseButtonAfterTimeout, $buttonToDisable) {
            enableCloseButtonAfterTimeout = enableCloseButtonAfterTimeout || true;
            var msg = '<p>' + (message || '') + '</p><div class="progress progress-striped active" style="margin-bottom:0;"><div class="progress-bar" style="width: 100%"></div></div>';
            var dialog = new BootstrapDialog({
                title: title || _backend.text.get.loading(),
                message: msg,
                closable: false,
                closeByBackdrop: false,
                closeByKeyboard: false,
                draggable: true,
                buttons: [{
                    id: 'wait-dialog-close-button',
                    icon: 'fal fa-times',
                    cssClass: 'center btn-primary',
                    action: function (me) {
                        me.close();
                    }
                }],
                onshow: function (me) {
                    if (enableCloseButtonAfterTimeout == true) {
                        setTimeout(function () {
                            me.enableButtons(true);
                        }, 6000);
                    }

                    if ($buttonToDisable && $buttonToDisable.length > 0) {
                        $buttonToDisable.attr('disabled', true);
                    }
                },
                onhide: function (me) {
                    if ($buttonToDisable && $buttonToDisable.length > 0) {
                        $buttonToDisable.attr('disabled', false);
                    }
                }
            });
            dialog.realize();
            dialog.enableButtons(false);
            dialog.open();
            return dialog;
        },
        showButtonSelectionModal: function (selectionModal) {
            var title = selectionModal.title;
            var contentContainerId = selectionModal.containerId;
            var content = getHtmlContent(contentContainerId, selectionModal.selectionButtons);

            var modal = new BootstrapDialog({
                title: title,
                message: content,
                draggable: true,
                size: selectionModal.size,
                buttons: selectionModal.footerButtons,
                closeByBackdrop: false,
            });
            modal.realize();
            modal.getModalBody().addClass('clearfix');
            modal.open();

            initListeners(modal, selectionModal);

            function initListeners(modal, selectionModal) {
                selectionModal.selectionButtons.forEach(button => {
                    var buttonsSelector = '#' + selectionModal.containerId + ' .' + button.containerClass;
                    var $container = $('#' + selectionModal.containerId);
                    $(document).off('click', buttonsSelector).on('click', buttonsSelector, function () {
                        var $selectionButtons = $(buttonsSelector);
                        disableButtons($selectionButtons);

                        return button.action($(this)).done(function () {
                            if (button.isCloseAfterAction === true) {
                                modal.close();
                            }
                        });

                        function disableButtons($selectionButtons) {
                            $selectionButtons.addClass('disabled');
                            $selectionButtons.attr('disabled', true);
                        }
                    });
                });
            }

            function getHtmlContent(modalContentId, selectionButtons) {
                var $container = $('<div id =' + modalContentId + ' class="form-group button-selection-modal-container"></div>');
                selectionButtons.forEach(selectionButton => {
                    $container.append(selectionButton.html);
                });

                return $container;
            }
        }
    };
    var _backend = {
        text: {
            get: {
                onlyNumbersAccepted: function () {
                    return _methods._backend._backendTexts['onlyNumbersAccepted'];
                },
                zeroNotAllowed: function () {
                    return _methods._backend._backendTexts['zeroNotAllowed'];
                },
                negativeValueNotAllowed: function () {
                    return _methods._backend._backendTexts['negativeValueNotAllowed'];
                },
                tooManyDecimalPlaces: function () {
                    return _methods._backend._backendTexts['tooManyDecimalPlaces'];
                },
                pleaseMatchTheRequestedFormat: function () {
                    return _methods._backend._backendTexts['pleaseMatchTheRequestedFormat'];
                },
                error: function () {
                    return _methods._backend._backendTexts['error'];
                },
                delete: function () {
                    return _methods._backend._backendTexts['delete'];
                },
                edit: function () {
                    return _methods._backend._backendTexts['edit'];
                },
                loading: function () {
                    return _methods._backend._backendTexts['loading'];
                },
                cancel: function () {
                    return _methods._backend._backendTexts['cancel'];
                },
                confirm: function () {
                    return _methods._backend._backendTexts['confirm'];
                }

            },
            set: {
                onlyNumbersAccepted: function (text) {
                    _methods._backend._backendTexts['onlyNumbersAccepted'] = text;
                },
                zeroNotAllowed: function (text) {
                    _methods._backend._backendTexts['zeroNotAllowed'] = text;
                },
                negativeValueNotAllowed: function (text) {
                    _methods._backend._backendTexts['negativeValueNotAllowed'] = text;
                },
                tooManyDecimalPlaces: function (text) {
                    _methods._backend._backendTexts['tooManyDecimalPlaces'] = text;
                },
                pleaseMatchTheRequestedFormat: function (text) {
                    _methods._backend._backendTexts['pleaseMatchTheRequestedFormat'] = text;
                },
                error: function (text) {
                    _methods._backend._backendTexts['error'] = text;
                },
                delete: function (text) {
                    _methods._backend._backendTexts['delete'] = text;
                },
                edit: function (text) {
                    _methods._backend._backendTexts['edit'] = text;
                },
                loading: function (text) {
                    _methods._backend._backendTexts['loading'] = text;
                },
                cancel: function (text) {
                    _methods._backend._backendTexts['cancel'] = text;
                },
                confirm: function (text) {
                    _methods._backend._backendTexts['confirm'] = text;
                },
            },
            documentUploadHelper: {
                upload: '',
                bePatientWhileUploadDocument: '',
                documentUpload_LieferantVisibilityChange_ToAllLieferanten: '',
                documentUpload_LieferantVisibilityChange_ToConcreteLieferanten: '',
                warning: '',
                cancel: '',
                confirm: '',
                errorUploadingDocument: '',
                chooseFiles: '',
                suppliers: '',
                modalHeader: '',
                uploadDisabled: '',
                documentTypesNotConfigured: '',
                insufficientRights: '',
                selectedFilesAreInvalid: '',
                someOfTheSelectedFilesContainUnsupportedFileExtensions_Extended: '',
                fileNotFound: '',
            }
        },
        _backendTexts: {},
        ajaxCall: function (type, url, data, callbacks) {
            var AjaxOptions = function (type, url, data, callbacks) {
                this.options = {
                    type: type ? type : undefined,
                    url: url ? url : undefined,
                    data: data ? JSON.stringify(data) : undefined,
                }
                this.callbacks = {
                    done: typeof callbacks !== 'undefined' && typeof callbacks.done !== 'undefined' ? callbacks.done : undefined,
                    fail: typeof callbacks !== 'undefined' && typeof callbacks.fail !== 'undefined' ? callbacks.fail : undefined
                }
            };
            var options = new AjaxOptions(type, url, data, callbacks);

            return ajaxCall(options)

            function ajaxCall(ajaxOptions) {
                var baseOptions = getBaseOptions();
                var opts = $.extend({}, baseOptions, ajaxOptions.options)

                return $.ajax(opts)
                    .done(function (xhr) {
                        if (typeof (ajaxOptions.callbacks.done) !== 'undefined') {
                            ajaxOptions.callbacks.done(xhr);
                        }

                        _methods.notification.processNotificatorMessages(xhr);
                    }).fail(function (xhr) {
                        if (typeof (ajaxOptions.callbacks.fail) !== 'undefined') {
                            ajaxOptions.callbacks.fail(xhr);
                        }

                        _methods.notification.showNotifyError(xhr);
                    });

                function getBaseOptions() {
                    return {
                        'contentType': 'application/json; charset=utf-8',
                        'dataType': 'json',
                    };
                }
            }
        }
    };

    var data = {
        escapeCharacters: function (text) {
            return text.replace(/(:|\.|\[|\]|,)/g, "\\$1");
        },
        formatInvariantDoubleToCulture: function (value, precision) {

            if (!precision) {
                precision = _methods.data.getMandantNumberPrecision() || 2;
            }
            value = value.toString();

            //Todo: replace invariant thousand for nothing
            // Desired: 1(,)099.50
            // Received: 99<cultureThousand>099<cultureDecimal>50
            var cultureThousandSeparator = _methods.data.getCultureInfo().ThousandSeparator;
            var cultureDecimalSeparator = _methods.data.getCultureInfo().DecimalSeparator;

            var invariantThousandSeparator = ',';
            var invariantDecimalSeparator = '.';

            if (value.indexOf(invariantDecimalSeparator) == -1) {
                return parseToLocaleString(value, precision);
            }

            var a = replaceSeparator(value, invariantThousandSeparator, '');

            var d = _methods.data.round(Number(a), precision).toFixed(precision);

            var culturedDouble = parseToLocaleString(d, precision);

            return culturedDouble;

            function replaceSeparator(value, separatorToReplace, toReplaceWith) {
                var regExp = new RegExp('\\' + separatorToReplace, 'g');
                return value.replace(regExp, toReplaceWith);
            }

            function parseToLocaleString(value, precision) {
                var cultureName = _methods.data.getCultureInfo().Name;
                var decimalFormatOptions = {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: precision,
                    useGrouping: false
                };
                return Number(value).toLocaleString(cultureName, decimalFormatOptions);
            }
        },
        getCultureInfo: function () {
            return _methods.data._cultureInfo;
        },
        getMandantNumberPrecision: function () {
            return _methods.data._mandantNumberPrecision;
        },
        getElementType: function ($element) {
            return $element[0].tagName == "INPUT" ? $element[0].type.toLowerCase() : $element[0].tagName.toLowerCase(); //<-- javascript
        },
        getIdWithoutAlias: function (id) {
            if (id.indexOf(".") !== -1) {
                id = id.split('.');
                if (id.length > 1) {
                    return id[id.length - 1];
                } else {
                    return id[0];
                }
            } else return id;
        },
        isBlankString: function (str) {
            return !str || /^\s*$/.test(str);
        },
        isValidDouble: function (toTest, hasCulture) {
            var thousandSeparator = hasCulture === true ? _methods.data.getCultureInfo().ThousandSeparator : ',';

            var regExp = new RegExp('\\' + thousandSeparator, 'g');
            toTest = toTest.toString().replace(regExp, '');

            var cultureDecimalSeparator = _methods.data.getCultureInfo().DecimalSeparator;

            var numberReSnippet = "(?:NaN|-?(?:(?:\\d+|\\d*\\" + cultureDecimalSeparator + "\\d+)(?:[E|e][+|-]?\\d+)?|Infinity))";
            var matchOnlyNumberRe = new RegExp("^(" + numberReSnippet + ")$");
            return matchOnlyNumberRe.test(toTest);
        },

        trimInput: function (selector) {
            if (typeof selector !== 'undefined') {
                var allInputs = $(selector).find(':input');
                allInputs.each(function () {
                    var $el = $(this);
                    if (_methods.validation.isNullOrEmptyString(allInputs) === true) {
                        $(this).val($.trim($(this).val()));
                    }

                });
            }
        },

        round: function (value, precision) {
            if (typeof precision === 'undefined' || +precision === 0)
                return Math.round(value);

            value = +value;
            precision = +precision;

            if (isNaN(value) || !(typeof precision === 'number' && precision % 1 === 0))
                return NaN;

            // Shift
            value = value.toString().split('e');
            value = Math.round(+(value[0] + 'e' + (value[1] ? (+value[1] + precision) : precision)));

            // Shift back
            value = value.toString().split('e');
            return +(value[0] + 'e' + (value[1] ? (+value[1] - precision) : -precision));
        },
        parseFloatFromCultureToInvariant: function (doubleWithCulture, precision) {

            if (typeof (precision) === 'undefined') {
                precision = _methods.data.getMandantNumberPrecision();
            }

            var thousandSeparator = _methods.data.getCultureInfo().ThousandSeparator;
            var decimalSeparator = _methods.data.getCultureInfo().DecimalSeparator;
            var isANumber = typeof (doubleWithCulture) === 'number' && !(isNaN(doubleWithCulture));
            var hasDecimalValues = doubleWithCulture % 1 === 0;

            if (isANumber && hasDecimalValues) //If variable comes in as number type
                return parseFloat(Number(doubleWithCulture).toFixed(precision));
            if (typeof (doubleWithCulture) === 'string' && doubleWithCulture.indexOf(thousandSeparator) === -1 && doubleWithCulture.indexOf(decimalSeparator) === -1) //If it comes in as string
                return parseFloat(Number(doubleWithCulture).toFixed(precision));

            var thousandSeparatorExp = new RegExp('\\' + thousandSeparator, 'g');
            var decimalSeparatorExp = new RegExp('\\' + decimalSeparator, 'g');

            doubleWithCulture = doubleWithCulture.toString();

            var invariantDouble = doubleWithCulture;
            if (doubleWithCulture.indexOf(thousandSeparator) != -1) {
                invariantDouble = invariantDouble.replace(new RegExp('[' + thousandSeparator + ']', 'g'), '');
            }

            if (doubleWithCulture.indexOf(decimalSeparator) != -1) {
                invariantDouble = invariantDouble.replace(new RegExp('[' + decimalSeparator + ']', 'g'), '.');
            }

            if (!_isValidInvariantDouble(invariantDouble)) //done like this because parseFloat likes to guess the next best thing.
                return undefined;

            var parsedInvariantDouble = parseFloat(Number(invariantDouble).toFixed(precision));
            return parsedInvariantDouble;

            function _isValidInvariantDouble(toTest) { //Copied from Validator.js
                var numberReSnippet = "(?:NaN|-?(?:(?:\\d+|\\d*\\.\\d+)(?:[E|e][+|-]?\\d+)?|Infinity))";
                var matchOnlyNumberRe = new RegExp("^(" + numberReSnippet + ")$");
                return matchOnlyNumberRe.test(toTest);
            }
        },

        trimInput: function (input) {
            if (typeof input !== 'undefined') {
                var $input = $(input);
                if (validation.isNullOrEmptyString($input.val()) === true) {
                    $input.val($.trim($input.val()));
                }
            }
        },

        repeatFunctionForEachModelName: function (models, functionName) {
            $.each(models, function (i, model) {
                functionName(model["modelName"]);
            });
        },
        setCultureInfo: function (key, value) {
            key = key.replace("Culture-", ''); //Remove prefix
            _methods.data._cultureInfo[key] = value;
        },
        setMandantNumberPrecision: function (value) {
            _methods.data._mandantNumberPrecision = value;
        },
        _cultureInfo: {},
        _mandantNumberPrecision: 3,
        sort: function (source, property) {
            return source.sort(function (a, b) {
                return a[property] > b[property];
            });
        },
        getUnique: function (array) {
            var n = [];
            for (var i = 0; i < array.length; i++) {
                if (n.indexOf(array[i]) == -1) n.push(array[i]);
            }
            return n;
        },
        getFloatPatternForInput: function (allowValueZero) {
            var cultureDecimalSeparator = _methods.data.getCultureInfo().DecimalSeparator;
            var precision = _methods.data.getMandantNumberPrecision();
            var needsEscaping = cultureDecimalSeparator == '.';
            var minimumValue = allowValueZero == true ? '0' : '0.' + '0'.repeat(precision == 0 ? 1 : precision - 1) + '1';
            var pattern = '^\\s*([' + minimumValue + '-9])\\d*(?:' + (needsEscaping ? '\\' : '') + cultureDecimalSeparator + '\\d{1,' + precision + '})?\\s*$';
            return pattern;
        },
        tryPrettifyJson: function (rawText) {
            try {
                var json = JSON.parse(rawText);
                var pretty = _methods.data.prettifyJson(json);
                return pretty;
            } catch (e) {
                return '<pre class="json-pretty">' + rawText + '</pre>';
            }
        },
        prettifyJson: function (json) {
            if (typeof json != 'string') {
                json = JSON.stringify(json, undefined, 2);
            }
            json = json.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
            var result = json.replace(/("(\\u[a-zA-Z0-9]{4}|\\[^u]|[^\\"])*"(\s*:)?|\b(true|false|null)\b|-?\d+(?:\.\d*)?(?:[eE][+\-]?\d+)?)/g, function (match) {
                var cls = 'number';
                if (/^"/.test(match)) {
                    if (/:$/.test(match)) {
                        cls = 'json-key';
                    } else {
                        cls = 'json-string';
                    }
                } else if (/true|false/.test(match)) {
                    cls = 'json-boolean';
                } else if (/null/.test(match)) {
                    cls = 'json-null';
                }

                return '<span class="' + cls + '">' + match + '</span>';
            });
            return '<pre class="json-pretty">' + result + '</pre>';
        },
        getBootstrapDatepickerLanguage: function () {


            var defaultFallback = 'en-GB';

            var lang = _methods.data.getCultureInfo().Name;

            if (!$.fn.datepicker || !$.fn.datepicker.dates) {
                return defaultFallback;
            }

            if (typeof (lang) == 'undefined') {
                return defaultFallback;
            }

            if ($.fn.datepicker.dates[lang]) {
                return lang;
            }

            lang = lang.split('-')[0];

            if ($.fn.datepicker.dates[lang]) {
                return lang;
            }

            return defaultFallback;
        },
        sanitizeValue: function ($input) {
            var value = _methods.form.getValueFromInput($input);
            if (typeof (value) == 'string' && (value.indexOf('<') !== -1 || value.indexOf('>') !== -1)) {

                var sanitized = value.replace(/</g, '%3C').replace(/>/g, '%3E');
                $input.val(sanitized);
                return sanitized;

            } else {
                return value;
            }
        },
        buildDataAttributesToHtml: function (dataAttributesArray) {
            if (!dataAttributesArray) {
                return '';
            }

            var dataAttributes = '';
            $.each(dataAttributesArray, function (i, attribute) {
                dataAttributes += 'data-' + attribute.key + '="' + attribute.value + '"' + ' ';
            });
            return dataAttributes;
        }
    };
    var form = {
        clearFormInputs: function (formSelector) {
            var $formInputs = $(formSelector).find(' :input');
            $.each($formInputs, function (i, input) {
                var $input = $(input);
                if (_methods.data.getElementType($input) === 'select') {
                    $input.find('option').prop('selected', false);
                    var $option = $input.find('option:first');
                    $option.prop('selected', 'selected');
                } else if (_methods.data.getElementType($input) === 'checkbox') {
                    $input.prop('checked', false);
                } else if ($input.hasClass('datepicker') == true) {
                    $input.val('').datepicker('update');
                } else {
                    $input.val('');
                }
            });
        },
        setContainerInputsReadonly: function (containerId) {
            this.getContainerInputElements(containerId).attr('readonly', true);
        },
        removeContainerInputsReadonly: function (containerId) {
            this.getContainerInputElements(containerId).attr('readonly', false);
        },
        fillDropdownBySimpleDropdownList: function (simpleDropdownList, $context) {
            if (simpleDropdownList == null || !simpleDropdownList.hasOwnProperty("DropdownId") || !simpleDropdownList.hasOwnProperty("IdOfSelectedItem"))
                return; //DropdownOptions MUST contain both properties;

            var dropdownFiller = {
                options: $.extend({
                    'DropdownId': simpleDropdownList.DropdownId,
                    'IdOfSelectedItem': simpleDropdownList.IdOfSelectedItem,
                    'Values': {},
                }, simpleDropdownList)
            };
            var $dropdown = getDropdown(dropdownFiller.options.DropdownId, $context);

            var hasDataAttributes = dropdownFiller.options.DataAttributes && dropdownFiller.options.DataAttributes.length > 0;

            $dropdown.empty();

            var keys = Object.keys(dropdownFiller.options.Values);
            var emptyOptionIndex = keys.indexOf('');

            if (emptyOptionIndex > -1) {
                keys.splice(emptyOptionIndex, 1);
                $dropdown.append('<option value=""></option>');
            }

            keys.forEach(function (key) {
                var kv = dropdownFiller.options.Values;
                var $option = $('<option value="' + key + '">' + kv[key] + '</option>');

                if (hasDataAttributes == true) {
                    for (var i = 0; i < dropdownFiller.options.DataAttributes.length; i++) {
                        var dataAttribute = dropdownFiller.options.DataAttributes[i];
                        //real and hard dependency on tuple from backend, revise
                        if (dataAttribute['Item1'] == key) {
                            $option.attr('data-' + dataAttribute['Item2'], dataAttribute['Item3']);
                        }
                    }
                }
                $dropdown.append($option);
            });

            setSelectedOption(dropdownFiller.options.IdOfSelectedItem);

            PubSub.publish('dropdown/initialized/' + simpleDropdownList.DropdownId);

            function getDropdown(dropdownId, $context) {
                if ($context) {
                    return $context.find('#' + dropdownId);
                } else {
                    return $('#' + dropdownId);
                }

            }

            function setSelectedOption(idOfSelectedItem) {
                //var selectedOptionLimitReached = false; //only one can be set to Selected
                var $optionToSelect = $dropdown.find('option[value="' + idOfSelectedItem + '"]');

                if ($optionToSelect.length == 0)
                    return;

                $optionToSelect.prop('selected', 'selected');
            }
        },
        fillFormInputs: function (formId, data, $context) {
            var keys = Object.keys(data);
            for (var i = 0; i < keys.length; i++) {
                var key = keys[i];
                var inputId = key;
                var value = data[key];

                if (key.indexOf(".") !== -1) //Key contains Alias
                    inputId = _methods.data.getIdWithoutAlias(key);

                var inputSelector = '#' + formId + ' #' + inputId + ':input';
                var $input = getInput(inputSelector, $context);

                if ($input.length === 0) {
                    continue;
                }

                if (_methods.data.getElementType($input) === 'select') {
                    var result = _tryIdThenValueForSelect();
                    if (result.length > 0) {
                        $.each($input.find('option:selected'), function (i, el) {
                            $(el).prop('selected', false);
                        });
                        result.prop('selected', true);
                    } else {
                        $(inputSelector + ' option:selected').prop('selected', false);
                        $input.val('');
                    }
                } else if (_methods.data.getElementType($input) === 'checkbox') {
                    $input.prop('checked', value);
                } else {
                    if ($input.attr('data-backend-type') == 'double') {
                        value = _methods.data.formatInvariantDoubleToCulture(value);
                    }
                    $input.val(value);
                }
            }

            function getInput(inputSelector, $context) {
                if ($context) {
                    return $context.find(inputSelector);
                } else {
                    return $(inputSelector);
                }
            }

            function _tryIdThenValueForSelect() {
                var foundById = $(inputSelector + ' option[value="' + value + '"]');
                if (foundById.length > 0)
                    return foundById;
            }
        },
        getCheckboxValue: function ($el) {
            return $el.prop("checked") ? 'true' : 'false';
        },
        getContainerInputElements: function (container) {
            if (typeof (container) == 'string') {
                return $('#' + container + ' :input');
            } else {
                return container.find(':input');
            }
        },
        getDatepickerInputInDatabaseFormat: function (element) {
            var rawDate = element.val();
            if (rawDate.indexOf("/") >= 0)
                rawDate = rawDate.replace(/\//g, '.');
            var parsedDate = DateTime.parseDate(rawDate);
            return moment(parsedDate).locale(_methods.data.getBootstrapDatepickerLanguage()).format('L');
            //return $.datepicker.formatDate("yy.mm.dd 00:00:00", parsedDate);
        },
        getInputFromObjectContainer($container, includeEmptyValues, asObject, useFormatForBinderBinding) {
            includeEmptyValues = includeEmptyValues || false;
            asObject = asObject || false;
            useFormatForBinderBinding = useFormatForBinderBinding || false;

            var me = this;
            var inputs = me.getContainerInputElements($container);

            var result;

            if (asObject == true) {
                result = new Object();
            } else {
                result = [];
            }

            $.each(inputs, function (i, input) {
                var $input = $(input);
                var key = $input.attr('id');
                var value = _methods.data.sanitizeValue($input);
                if (includeEmptyValues == true || !_methods.validation.isNullOrEmptyString(value)) {
                    if (Array.isArray(result) == false) {
                        result[key] = value;
                    } else {
                        if (useFormatForBinderBinding) {
                            result.push({
                                Key: key,
                                Value: value,
                            });
                        } else {
                            result.push({
                                key: key,
                                value: value,
                            });
                        }
                    }
                }
            });
            return result;
        },
        getInputFromContainer: function (containerId, includeEmptyValues, asObject) {
            return this.getInputFromObjectContainer($('#' + containerId), includeEmptyValues, asObject);
        },
        getValueFromInput: function ($input) {
            var me = this;
            var value;
            if (!($input instanceof jQuery))
                $input = $($input);
            if (_methods.validation.isCheckbox($input))
                value = me.getCheckboxValue($input);
            else
                value = $input.val();
            return value;
        },
        hasAttribute: function (element, attributeName) {
            var attribute = element.attr(attributeName);
            return (typeof attribute !== 'undefined' && attribute !== false);
        },
        hasData: function (element, dataName) {
            var dataValue = element.data(dataName);
            return (typeof dataValue !== 'undefined' && dataValue !== false);
        },
        initDatePickers: function ($datepickers, externalOptions) {




            var languageName = _methods.data.getBootstrapDatepickerLanguage();
            var options = $.extend(true, {}, $.fn.datepicker.dates[languageName], getDefaultOptions(), externalOptions);

            var culturedDateSeparator = _methods.data.getCultureInfo().DateSeparator;
            var $dps = $datepickers || getNonSearchDatepickers();

            if ($dps.length === 0) {
                return;
            }

            $dps.datepicker(options);
            $dps.attr('pattern', '\\d{2}' + culturedDateSeparator + '\\d{2}' + culturedDateSeparator + '\\d{4}');
            attachEvents($dps);

            function getNonSearchDatepickers() {
                var $allDatepickers = $('.datepicker');
                return $allDatepickers.not(function (i, el) {
                    return $(el).parents('#filters').length == 1;
                });
            }

            function getDefaultOptions() {
                return {
                    language: languageName,
                    autoclose: true,
                    todayHighlight: true,
                    calendarWeeks: true,
                };
            }

            function attachEvents($datepickers) {
                attachOnChangeEvents($datepickers);
                attachOnShowEvents($datepickers);

                function attachOnShowEvents($datepickers) {
                    attach($datepickers, 'show', addNavigationButtons);

                    function addNavigationButtons(e) {
                        var buttonsSelector = '.datepicker-days,.datepicker-months,.datepicker-years';
                        addButtons('.datepicker.datepicker-dropdown.dropdown-menu', buttonsSelector);
                        addButtons('.datepicker.datepicker-inline', buttonsSelector);

                        function addButtons(datepickersSelector, buttonsSelector) {
                            var $popups = $(datepickersSelector).find(buttonsSelector);
                            var $needAdjustmentLeftArrow = $popups.find('.prev i.icon-arrow-left');
                            var $needAdjustmentRightArrow = $popups.find('.next i.icon-arrow-right');

                            $needAdjustmentLeftArrow.removeClass('icon-arrow-left').addClass('fal fa-chevron-left');
                            $needAdjustmentRightArrow.removeClass('icon-arrow-right').addClass('fal fa-chevron-right');
                        }
                    };
                }

                function attachOnChangeEvents($datepickers) {
                    var cb = getOnChangeDateCallback();
                    attach($datepickers, 'changeDate', cb);
                    attach($datepickers, 'dp.change', cb);

                    function getOnChangeDateCallback() {
                        return function (e) {
                            if (e.date !== e.oldDate) {
                                $(this).trigger('input');
                            }
                        };
                    }
                }

                function attach($datepickers, eventName, fn) {
                    $datepickers.on(eventName, fn);
                }
            }

        },
        setOptionAsSelected: function ($select, optionValue) {
            if (_methods.data.getElementType($select) !== 'select') {
                return;
            }
            var $option = $select.find('option[value="' + optionValue + '"]');
            $.each($select.find('option:selected'), function (i, el) {
                $(el).removeProp('selected');
                $(el).removeAttr('selected');
            });

            $option.prop('selected', 'selected');
        }
    };
    var grid = {
        data: {
            //TODO DPH: If index is known, why call this method? Remove index parameter
            determineIndexOfSelectedRow: function (row, index, tableId) {
                var hasData = $('#' + tableId).bootstrapTable('getOptions').totalRows > 0;

                if (!hasData) {
                    return;
                }

                var selectedRowIndex;
                if (typeof (index) === 'undefined')
                    selectedRowIndex = findIndexOfSelectedRow(row, tableId);
                else
                    selectedRowIndex = index; //?
                return selectedRowIndex;

                function findIndexOfSelectedRow(row, tableId) {
                    var $table = $('#' + tableId);
                    var tableOptions = $table.bootstrapTable('getOptions'),
                        uniqueId = tableOptions.uniqueId,
                        pageSize = tableOptions.pageSize,
                        pageNumber = tableOptions.pageNumber;

                    if (!_methods.validation.isNullOrEmptyString(uniqueId)) {
                        var id = row[uniqueId];
                        return $('#' + tableId).find('tr[data-uniqueid=' + id + ']').data('index');
                    }

                    $.each($('#' + tableId).bootstrapTable('getData', { useCurrentPage: true }), function (rowIndex, rowData) {
                        if (row == rowData)
                            index = rowIndex;
                    });

                    // This returns the correct data-index value for the row, instead of it's "shown" index (page2, first row --->ie  "shown" index of 0, which would be incorrect)
                    return index * pageSize * pageNumber;
                }
            },
            gatherGridData: function (modelName, useCurrentPage) {
                var result = $('#' + modelName + 'Table').bootstrapTable('getData', { useCurrentPage: (typeof useCurrentPage == 'undefined' ? true : useCurrentPage) });
                if ($.type(result) === 'object')
                    return [];
                return result;
            },
            gatherGridIds: function (modelName, idColumnName, useCurrentPage) { //TODO DPH: Rename this to : gatherSingleColumnValues
                var rows = _methods.grid.data.gatherGridData(modelName, useCurrentPage);

                if ($.type(rows) === 'object' || rows.length === 0) //When the table has no rows, the table object is returned.
                    return [];

                var ids = [];
                $.each(rows, function (i, row) {
                    ids[i] = row[idColumnName]; //Case sensitive!
                });
                return ids;
            },
            gatherGridSelections: function (modelName) {
                return $('#' + modelName + 'Table').bootstrapTable('getSelections');
            },
            gatherSingleRowFromGrid: function ($table, rowIndex) {
                return $table.bootstrapTable('getData')[rowIndex];
            },
            //TODO DPH: Name is incorrect, it works for any column, not just editables
            getEditableColumnIndexByFieldName: function ($table, headerId) {
                var headers = $table.find('th');
                var editableCellColumnIndex;
                $.each(headers, function (index, _) {
                    var header = $(this).data('field');
                    if (header == headerId) {
                        editableCellColumnIndex = index;
                    }
                });
                return editableCellColumnIndex;
            },
            isColumnInGrid: function ($table, columnName) {
                var $rows = $table.bootstrapTable('getVisibleColumns');
                var columns = $rows.map(x => x.field);
                return $.inArray(columnName, columns) !== -1;
            }
        },
        editable: {
            checkRowAfterEditableSave: function (tableId, $edit) {
                var $tableRow = $edit.parents('tr');

                if (hasRowCheckbox($tableRow) === false) {
                    return;
                }
                var $table = $('#' + tableId);
                var uniqueIdName = $table.bootstrapTable('getOptions').uniqueId;
                var tableActionStateDeterminator = $table.data('bootstrap.table').options['tableActionStateDeterminator'];
                var value = $tableRow.data((uniqueIdName ? 'uniqueid' : 'index'));

                setTimeout(function () { // This timeout is set because otherwise the 'onCheck' event for bootstrap would be called before the editable value has been set.

                    var value = $tableRow.data((uniqueIdName ? 'uniqueid' : 'index'));
                    checkRow($table, $tableRow, uniqueIdName, value);

                    if (typeof (tableActionStateDeterminator) == 'function') {
                        tableActionStateDeterminator($table.attr('id'));
                    } else {
                        _methods.grid.ui.determineConfirmTableActionButtonState($table.attr('id'));
                    }

                    function checkRow($table, $tableRow, uniqueIdName, value) {
                        $tableRow.addClass('selected');
                        if (uniqueIdName) {
                            $table.bootstrapTable('checkBy', { field: uniqueIdName, values: [value] });
                        } else {
                            $table.bootstrapTable('check', value);
                        }
                    }

                }, 200);

                function hasRowCheckbox($row) {
                    var el = $row.find('td').siblings('.bs-checkbox.checkboxFormatter').find('input');
                    return _methods.validation.isCheckbox(el);
                }
            },
            disableEditables: function (selectorId) {
                $('#' + selectorId + ' .editable').editable('disable');
            },
            getEditableServerUpdateBaseOptions: function (fieldName) {
                return {
                    send: 'auto',
                    url: '',
                    pk: function () {
                        return $(this).attr('pk');
                    },
                    success: function (response, newValue, $editable) {
                        var $that = $(this);
                        $editable = $editable ? $editable : $that;

                        var isSuccess = false;
                        if (typeof (response) === 'object' && typeof (response['IsSuccess']) !== 'undefined') {
                            isSuccess = response['IsSuccess'] === true ? 'Ok' : undefined;
                        } else {
                            isSuccess = response;
                        }

                        if (isSuccess === 'Ok') {
                            if (typeof (response.Notifications) !== 'undefined' && typeof (response.Notifications.Data) !== 'undefined') {
                                _methods.notification.processNotificatorMessages(response.Notifications.Data);
                            }

                            /* There are two calls to 'success' with different constructors in the bootstrap-editable.js (G: 2096, 247)
                             , whereas 2096 is called on when an existing html element
                             The difference is:
                                247  --> new editable element (?)
                                2096 --> when an existing html element is converted to editable... (?)
                                In any case, only 247 works
                            */
                            if (typeof (newValue) === 'object' && typeof (newValue['success']) === 'function') {
                                return;
                            }

                            var tableId = $editable.parents('table').attr('id');
                            var $td = $editable.closest('td');
                            var $editableCell = $td.find('a');
                            var okIcon = '<i id="saveOk" class="fas fa-check text-success pull-right"></i>';
                            var rowUniqueId = $td.parents('tr').data('uniqueid');

                            if ($td.find('i#saveOk').length === 0) {
                                $td.append(okIcon);
                            }

                            var $table = $editable.parents('table');
                            var $iconInCell = $td.find('i#saveOk');
                            $iconInCell.hide();
                            $iconInCell.fadeIn(250).fadeOut(500);
                            $editableCell.html(newValue);
                            $editableCell.editable('setValue', newValue);
                            $editableCell.delay(750).fadeIn(250);

                            if (rowUniqueId) {
                                _methods.grid.editable._updateTableRowData($table, rowUniqueId, fieldName, newValue, $editable.data('editable').options.type);
                            }

                        } else if (typeof (response.status) !== 'undefined' && response.status == 'error') {
                            return this.error(response);
                        }

                        _methods.grid.editable.showNextEditable(tableId, $editable);

                        _methods.grid.editable.checkRowAfterEditableSave(tableId, $editable);

                    }, error: function (xhr, newValue) {
                        return xhr.responseJSON?.message ? xhr.responseJSON.message : _methods.notification._getErrorMessage(xhr);
                    },
                };
            },
            initializeEditableInGrid: function (options) {
                // To implement this any post processing would need to be moved into the afterInit function. Also, try with lower delay. as the current one is noticeable
                //if (!editableInitPendingList.includes(options.fieldName)) {
                //    editableInitPendingList.push(options.fieldName);
                //    $.logit.debounce(init, 500);
                //}
                init();
                function init() {
                    /*
                        modelName = to find table
                        fieldName = to find column in table
                        pkPropertyName = to find value of primary key of row in table
                        valuePropertyName = to find value of named property and set it for the editable
                        editableOptionsObj = internal editable options
                        additionalDataKeysArray = keys to be searched in the row data to add as data attributes in the editable
                        customDataKeyValuesArray = ??
                        customRowCheckLogic = ??
                        afterInit = after init is finished
                    */

                    var tableData = _methods.grid.data.gatherGridData(options.modelName, true);
                    var editableCellClass = 'editable-cell-' + options.fieldName;

                    generateEditablesHtml(options, tableData, editableCellClass);

                    var editablesSelector = '.' + editableCellClass;

                    if (options.dataTypeOverride == 'logitDouble') {
                        formatInvariantDoubleToCultureOnInit(editablesSelector);
                    }

                    var $editables = $(editablesSelector);

                    var emptyText = typeof (options.emptytext) === 'undefined' ? '___' : options.emptytext;
                    $.fn.editable.defaults.emptytext = emptyText;

                    var extendedEditableOptionsObj = $.extend({}, getInternalEditableOptionsObj(), options.editableOptionsObj);

                    //The init event must be attached before the editable is initialized
                    attachInitEvent(options);

                    $editables.editable(extendedEditableOptionsObj);

                    attachEvents($editables, options);

                    removeFromPendingList(options.fieldName);

                    if (options.afterInit) {
                        options.afterInit();
                    }

                    function removeFromPendingList(fieldName) {
                        var index = editableInitPendingList.indexOf(fieldName);
                        editableInitPendingList.splice(index, 1);
                    }

                    function attachInitEvent(options) {
                        if (typeof (options.editButton) === 'undefined') {
                            return;
                        }

                        if (options.editButton.isAppended == false) {
                            return;
                        }

                        $editables.on('init', function (e, editable) {
                            var text = options.editButton.label || options && options.tooltip && options.tooltip.text;
                            _methods.grid.editable.icons.edit.add(editable.$element, text);
                        });
                    }

                    function attachEvents($editables, options) {
                        initSave($editables, options);
                        initShown($editables, options);
                        initHidden($editables, options);

                        function initSave($editables, options) {
                            // Functions to run after saving
                            $editables.off('save').on('save', function (e, params) {
                                var submitValue = params.newValue;
                                var $ed = $(this);
                                var newValue = params.newValue;
                                if (options.dataTypeOverride == 'logitDouble') {
                                    var t = _methods.data.parseFloatFromCultureToInvariant(newValue);
                                    newValue = _methods.data.formatInvariantDoubleToCulture(t);
                                    params.newValue = newValue;
                                }

                                var tableId = $ed.parents('table').attr('id');
                                $ed.html(newValue);
                                $ed.editable('setValue', submitValue);

                                _methods.grid.editable.showNextEditable(tableId, $ed);

                                // For when a custom save method is desired
                                if (options.editableOptionsObj && options.editableOptionsObj.save && typeof options.editableOptionsObj.save === "function") {
                                    options.editableOptionsObj.save($ed, params);
                                }

                                _methods.grid.editable.checkRowAfterEditableSave(tableId, $ed);
                            });
                        }

                        function initShown($editables, options) {
                            $editables.off('shown').on('shown', function (e, editable) {

                                var $ed = $(this);

                                if (editable.input.type !== 'date') {
                                    setTimeout(function () {
                                        editable.input.$input.get(0).select();
                                    }, 0);
                                } else {
                                    $('.datepicker:first()').trigger('show'); //--> uses the previously attach handler for datepickers 'show'
                                }

                                // For when a custom show method is desired
                                if (options.editableOptionsObj && options.editableOptionsObj.onShown && typeof options.editableOptionsObj.onShown === "function") {
                                    options.editableOptionsObj.onShown($ed);
                                }

                                if (options.dataTypeOverride != 'logitDouble') {
                                    return;
                                }

                                var cultureName = _methods.data.getCultureInfo().Name;

                                editable.input.$input.attr('lang', cultureName);

                                var decimalFormatOptions = {
                                    minimumFractionDigits: 2,
                                    maximumFractionDigits: _methods.data.getMandantNumberPrecision(),
                                    useGrouping: false
                                };

                                var val;
                                if (typeof (editable.value) == typeof (0)) {
                                    val = editable.value;
                                } else {
                                    val = _methods.data.parseFloatFromCultureToInvariant(editable.input.$input.val());
                                }

                                var formatted = _methods.data.formatInvariantDoubleToCulture(val);
                                var pattern = _methods.data.getFloatPatternForInput();

                                //note: lang + type="number" attributes dont work in unison in chrome
                                editable.input.$input.attr('type', 'text');
                                editable.input.$input.attr('pattern', pattern);
                                editable.input.$input.val(formatted);

                                editable.input.$input[0].oninput = function (e) {
                                    $(e.target).parents('form')[0].reportValidity();
                                };

                                editable.input.$input[0].oninvalid = function (e) {
                                    var message = validation.getDoubleValidationMessage(e.target.value);
                                    setValidationMessage(message);
                                };

                                function setValidationMessage(message) {
                                    var precision = _methods.data.getMandantNumberPrecision();
                                    if (message !== true) {
                                        e.target.setCustomValidity(message);
                                    } else {
                                        //Clear validation message
                                        e.target.setCustomValidity('');
                                    }
                                }
                            });
                        }


                        function initHidden($editables, options) {
                            $editables.off('hidden').on('hidden', function (e) {
                                var $input = $(this);
                                var editableData = $input.data('editable');

                                if (options.editableOptionsObj && options.editableOptionsObj.onHidden && typeof options.editableOptionsObj.onHidden === "function") {
                                    options.editableOptionsObj.onHidden($input);
                                }
                            });
                        }
                    }

                    function getInternalEditableOptionsObj() {
                        var commonInternalOptions = {
                            success: function (t, value) {
                                if (hasValidPk(this) === false) {
                                    return;
                                }

                                _methods.grid.editable.data.memory.add.item($(this).editable(), value);

                                function hasValidPk(that) {
                                    var $editable = $(that);

                                    if ($editable.attr('pk') !== '') {
                                        return true;
                                    }

                                    var editableData = $editable.data('editable');

                                    if (typeof editableData !== 'undefined' && typeof editableData.options.pk !== 'function') {
                                        return typeof editableData.options.pk !== 'undefined';
                                    }

                                    if (typeof editableData !== 'undefined' && typeof editableData.options.pk === 'function') {
                                        var fnValue = editableData.options.pk.apply(that);
                                        return typeof fnValue !== 'undefined';
                                    }

                                    return false;
                                }
                            },
                            error: function (xhr) {
                                console.debug('new error');
                            }
                        };

                        if (options.dataTypeOverride && options.dataTypeOverride === 'logitDouble') {
                            var precision = _methods.data.getMandantNumberPrecision();

                            return {
                                //'dataType':'text',
                                'validate': function (value) { //wouldnt just validateEditableInput(value) work?
                                    var onlyNumbersAccepted = _backend.text.get.onlyNumbersAccepted();
                                    var zeroNotAllowed = _backend.text.get.zeroNotAllowed();
                                    var negativeValueNotAllowed = _backend.text.get.negativeValueNotAllowed();
                                    var isZeroAllowed = true;
                                    return _methods.grid.editable.validateEditableDouble(value, isZeroAllowed, onlyNumbersAccepted, zeroNotAllowed, negativeValueNotAllowed);
                                },
                                // 'display': function (value, response) {
                                //ONLY affects displayed property.
                                // value = always comes in with . as decimal separator
                                // },
                                'step': 'any',
                                'success': function (_, value) {
                                    var invariantDouble = _methods.data.parseFloatFromCultureToInvariant(value);
                                    commonInternalOptions.success.call(this, _, invariantDouble);
                                }
                            };
                        } else {
                            return commonInternalOptions;
                        }
                    }

                    function formatInvariantDoubleToCultureOnInit(editablesSelector) {
                        $(editablesSelector).on('init', function (e, editable) {
                            var invariantDouble = Number(editable.$element.text());

                            if (typeof (invariantDouble) == typeof (0.00) && !isNaN(invariantDouble)) {
                                var culturedDouble = _methods.data.formatInvariantDoubleToCulture(invariantDouble);
                                editable.$element.text(culturedDouble);
                                editable.setValue(culturedDouble);
                            }
                        });
                    }

                    function generateEditablesHtml(options, tableData, editableCellClass) {
                        var $table = $('#' + options.modelName + 'Table');
                        var editableColumnIndex = _methods.grid.data.getEditableColumnIndexByFieldName($table, options.fieldName);

                        $.each(tableData, function (rowIndex, rowData) {
                            var $row = $($table.find('tbody tr')[rowIndex]);
                            var editablePk = typeof (options.pkPropertyName) == 'function' ? options.pkPropertyName(rowData) : findAttributeValueInData(rowData, options.pkPropertyName);
                            var editableValue = findAttributeValueInData(rowData, options.valuePropertyName);
                            var $cell = $($row.find('td')[editableColumnIndex]);
                            $cell.off('click'); //Removing all click events on this cell. (Original target is to remove the RowClick event on this cell. But removes all click events on this cell. )
                            generateEditableHtml(rowData, $cell, editablePk, editableValue, editableCellClass, options.iconOptions);
                        });

                        function findAttributeValueInData(rowData, attribute) {
                            var attributeValue = '';
                            $.each(rowData, function (cellKey, cellValue) {
                                if (cellKey === attribute) {
                                    attributeValue = cellValue;
                                    return;
                                }
                            });
                            return attributeValue;
                        }

                        function generateEditableHtml(rowData, $cell, editablePk, editableValue, editableCellClass, iconOptions) {
                            var dataAttributesArray = [];
                            if (options.dataType === 'date') {
                                var format = _methods.data.getCultureInfo().DateFormat ? _methods.data.getCultureInfo().DateFormat.toLowerCase() : 'dd.mm.yyyy';
                                dataAttributesArray.push({
                                    key: 'format',
                                    value: format
                                });


                                var lang = _methods.data.getBootstrapDatepickerLanguage();
                                if (lang == 'en-GB') {
                                    lang = 'en';
                                }

                                //Sets the language for the editable datepicker
                                $.extend(true, options.editableOptionsObj, {
                                    datepicker: {
                                        language: lang,
                                    }
                                });

                                loadLanguageIfNotInitialized(_methods.data.getBootstrapDatepickerLanguage());

                                //As the JsonSerializer has been switched to newtonsoft, this conversion should not be needed anymore
                                if (editableValue.indexOf('/Date(') !== -1) {
                                    var temp = editableValue.replace(/\//g, '').replace('Date', '').replace('(', '').replace(')', ''); //TODO DPH: There mus be a better way :-/
                                    editableValue = new Date(parseInt(temp)).toLocaleDateString(_methods.data.getCultureInfo().Name); //new Date(parseInt(temp)).toLocaleDateString();
                                }
                            }

                            if (options.additionalDataKeysArray && options.additionalDataKeysArray.length > 0) {
                                $.each(options.additionalDataKeysArray, function (i, key) {
                                    dataAttributesArray.push({
                                        key: key,
                                        value: rowData[key]
                                    });
                                });
                            }

                            if (options.customDataKeyValuesArray && options.customDataKeyValuesArray.length > 0) {
                                $.each(options.customDataKeyValuesArray, function (i, kv) {
                                    dataAttributesArray.push({
                                        key: kv.key,
                                        value: kv.value
                                    });
                                });
                            }

                            if (options.customRowCheckLogic && options.customRowCheckLogic === true) {
                                dataAttributesArray.push({
                                    key: 'custom-row-check-logic',
                                    value: true
                                });
                            }

                            if ($cell.find('.editable').length) {
                                $cell.find('.editable').each(function () {
                                    var $ed = $(this);
                                    if ($ed.data('editable')) {
                                        $ed.editable('destroy');
                                        $ed.removeData('editable');
                                        $ed.removeData('editableContainer');
                                    }
                                });
                            }

                            var html = _methods.grid.ui.formatterBuilder('editable' + ' ' + editableCellClass, '', editablePk, editableColumnIndex, editableValue ? editableValue : options.defValue, options.dataType, dataAttributesArray, iconOptions);
                            $cell.html(html);

                            function loadLanguageIfNotInitialized(language) {
                                //It loads it, but the plugin has already initialized and doesnt pick up the new language
                                if (!$.fn.bdatepicker.dates || !$.fn.bdatepicker.dates[language]) {
                                    $.fn.bdatepicker.dates[language] = $.fn.datepicker.dates[language];
                                }
                            }
                        }
                    }
                }
            },
            showNextEditable: function (tableId, $that) {
                var cellIndex = $that.parent().index();
                var $nextEditable = getNext($that, cellIndex, tableId);

                if ($nextEditable.length > 0) {
                    $nextEditable.editable('show');
                }

                function getNext($that, cellIndex, tableId) {
                    var hasNext = false;
                    var pk = $that.parents('tr').data('uniqueid');
                    var $nextRow = $('#' + tableId).find('tr[data-uniqueid="' + pk + '"]').next();
                    var $nextEditable;

                    var isActive = checkIsActive($nextRow);
                    hasNext = typeof ($nextRow) !== 'undefined';
                    $nextEditable = $nextRow.children().eq(cellIndex).find('a.editable');

                    while (isActive === false && hasNext == true) {
                        $nextRow = $nextRow.next();
                        hasNext = typeof ($nextRow) !== 'undefined';
                        isActive = checkIsActive($nextRow);
                        if (hasNext === false && isActive === false) {
                            return false;
                        }
                        $nextEditable = $nextRow.children().eq(cellIndex).find('a.editable');
                    }

                    return $nextEditable;

                    function checkIsActive($row) {
                        return $row.find('a.editable-disabled').length == 0;
                    }
                }
            },
            icons: {
                /*
                 options:{
                    tooltip{
                        text:''
                    },
                    alignment:center|right
}
                 */
                warning: {
                    add: function ($editables, options) {
                        var warningIconSelector = 'i.fal.fa-info-circle.table-cell-warning';
                        var $tds = $editables.parent('td');
                        if ($tds.find(warningIconSelector).length === 1) {
                            return;
                        }

                        $tds.append('<i class="fal fa-info-circle table-cell-warning"></i>');

                        if (options && options.tooltip && options.tooltip.text) {
                            _methods.ui.addTooltip($tds.find(warningIconSelector), options.tooltip.text);
                        }
                    },
                    remove: function ($editables) {
                        $editables.parent('td').find('i.table-cell-warning').remove();
                    },
                },
                edit: {
                    add: function ($editable, text) {
                        var iconSelector = 'i.fa.icon-pencil.table-cell-edit';
                        var $tds = $editable.parent('td');
                        if ($tds.find(iconSelector).length === 1) {
                            return;
                        }

                        var icon = _methods.grid.ui.editIconBuilder('-' + $editable.attr('pk'));
                        $tds.append(icon);
                        _methods.ui.addTooltip($tds.find(iconSelector), text);
                    },
                },
            },
            validateEditableDouble: function (value, isZeroAllowed, onlyNumbersAcceptedMsgText, zeroIsNotAllowedMsgText, negativeValueNotAllowed) {
                //var isChrome = /Chrome/.test(navigator.userAgent) && /Google Inc/.test(navigator.vendor);
                //var hasCulture = isChrome == false;
                //if (!_methods.data.isValidDouble(value, hasCulture)) {
                if (!_methods.data.isValidDouble(value, true)) {
                    return onlyNumbersAcceptedMsgText;
                }

                if (isZeroAllowed === false && value == 0) {
                    return zeroIsNotAllowedMsgText;
                }

                if (_methods.data.parseFloatFromCultureToInvariant(value) < 0) {
                    return negativeValueNotAllowed;
                }
                //return nothing otherwise!
            },
            data: {
                memory: {
                    add: {
                        table: function (tableId) {
                            var tableEditableData = _methods.grid.editable.data.table.get.table(tableId);

                            if (tableEditableData.tableEditableItems.length === 0) {
                                return;
                            }

                            EditableDataContainer.addTable(tableEditableData);
                        },
                        item: function ($editable, value) {
                            var tableEditableItem = new logit.classes.TableEditableItem($editable, value);
                            EditableDataContainer.addItem(tableEditableItem);
                        },
                    },
                    clear: {
                        table: function (tableId) {
                            EditableDataContainer.clearTable(tableId);
                        },
                        item: function (tableId, pk, columnIndex) {
                            EditableDataContainer.clearItem(tableId, pk, columnIndex);
                        }
                    },
                    get: {
                        table: function (tableId) {
                            var tableEditableData = EditableDataContainer.getTable(tableId);
                            return tableEditableData;
                        },
                        item: function (tableId, pk, columnIndex) {
                            var tableEditableItem = EditableDataContainer.getItem(tableId, pk, columnIndex);
                            return tableEditableItem;
                        },
                    },
                    update: {
                        item: function ($editable, newValue) {
                            var tableEditableItem = new logit.classes.TableEditableItem($editable, newValue);
                            EditableDataContainer.updateItem(tableEditableItem);
                        }
                    },
                },
                table: {
                    set: {
                        table: function (tableId, removeFromMemory) {
                            var tableEditableDatas = _methods.grid.editable.data.memory.get.table(tableId);

                            if (typeof (tableEditableDatas) === 'undefined') {
                                return;
                            }
                            var $table = $('#' + tableId);

                            for (var i = 0; i < tableEditableDatas.length; i++) {
                                var tableEditableItem = tableEditableDatas[i];
                                var $editable = findEditableInRow(tableEditableItem);
                                $editable.editable('setValue', tableEditableItem.value);
                                $editable.html(tableEditableItem.value);

                                if (tableEditableItem.wasSelected === true) {
                                    $editable.addClass('editable-unsaved');
                                }
                            }


                            if (typeof (removeFromMemory) === 'undefined' || removeFromMemory === true) {
                                //    EditableDataContainer.clearTable(tableId);
                            }

                            function findEditableInRow(tableEditableItem) {
                                return $('#' + tableId).find(buildSelector(tableEditableItem));

                                function buildSelector(tableEditableItem) {
                                    let result = 'tbody td a.editable[pk="' + tableEditableItem.pk + '"][data-index="' + tableEditableItem.columnIndex + '"]';
                                    result = addDataAttributesToSelector(result, tableEditableItem);
                                    return result;

                                    function addDataAttributesToSelector(result, tableEditableItem) {
                                        if (Object.keys(tableEditableItem.dataAttributes).length == 0) {
                                            return result;
                                        }

                                        for (const [key, value] of Object.entries(tableEditableItem.dataAttributes)) {
                                            result += `[${key}="${value}"]`;
                                        }

                                        return result;
                                    }
                                }
                            }
                        },
                        item: function (tableId, removeFromMemory) { },
                    },
                    get: {
                        table: function (tableId) {
                            var editablesSelector = 'a.editable' + '.editable-unsaved';
                            var data = buildData(tableId, editablesSelector);
                            return new logit.classes.TableEditableData(tableId, data);

                            function buildData(tableId, editablesSelector) {
                                var editables = $('#' + tableId).find('tbody td ' + editablesSelector);
                                return $.map(editables, function (d, i) {
                                    var $d = $(d);
                                    return {
                                        'pk': $d.attr('pk'),
                                        'value': $d.editable('getValue', true),
                                        'wasSelected': $d.hasClass('editable-unsaved'),
                                    };
                                });
                            }
                        },
                        item: function (tableId) { },
                    },
                },
            },
            _updateTableRowData: function ($table, rowUniqueId, fieldName, newValue, dataType) {
                var obj = {
                    id: rowUniqueId,
                    row: {}
                };

                if (dataType == 'date') {
                    newValue = moment(newValue).locale(_methods.data.getBootstrapDatepickerLanguage()).format('L');
                }

                obj.row[fieldName] = newValue;
                $table.bootstrapTable('updateByUniqueId', obj);
            }
        },
        ui: {
            prependButtonToToolbar: function (buttonSelector, tableId, optionalTooltipText) {
                internalMethods.grid.ui.addButtonToToolbar('prepend', buttonSelector, tableId, optionalTooltipText);
            },
            appendButtonToToolbar: function (buttonSelector, tableId, optionalTooltipText) {
                internalMethods.grid.ui.addButtonToToolbar('append', buttonSelector, tableId, optionalTooltipText);
            },
            determineConfirmTableActionButtonState: function (tableId) {
                var $table = $('#' + tableId);
                var $selectedRows = $table.find('tr.selected'); //'bootstrapTable('getSelections');
                var selectedRowsCount = $selectedRows.length;
                var hasRowsMarkedAsInvalid = $selectedRows.hasClass('invalid-row');
                selectedRowsCount > 0 && hasRowsMarkedAsInvalid === false ? _methods.ui.enableConfirmTableActionButton(tableId) : _methods.ui.disableConfirmTableActionButton(tableId);
            },
            disableCheckAllTable: function (modelName) {
                var checkAllBox = $('input#' + modelName + 'checkAll');
                checkAllBox.prop('disabled', true);

                var $tableCheckboxes = $('#' + modelName + 'Table').find(':input[type="checkbox"]');
                $tableCheckboxes.prop('disabled', 'disabled');
            },
            enableCheckAllTable: function (modelName) {
                var $checkAllBox = $('input#' + modelName + 'checkAll');
                $checkAllBox.prop('disabled', false);

                var $tableCheckboxes = $('#' + modelName + 'Table').find('tbody tr:not(.cancelled-row-state) :input[type="checkbox"]');
                $tableCheckboxes.prop('disabled', false);
            },
            formatterBuilder: function (formatterClass, title, pk, index, value, dataType, dataAttributesArray, iconOptions) {
                return [
                    '<a class="' + formatterClass +
                    '" href="javascript:void(0)" ' +
                    'title="' + title + '" ' +
                    'data-type="' + dataType + '" ' +
                    'pk="' + pk + '" ' +
                    'data-index=' + index + ' ' +
                    _methods.data.buildDataAttributesToHtml(dataAttributesArray) + ' >',
                    value, '</a>',
                    buildIcon(iconOptions)
                ].join('');


                function buildIcon(iconOptions) {
                    if (!iconOptions) {
                        return '';
                    }
                    var $wrapper = $('<div class="table-icon-container float-right"></div>');
                    if (!Array.isArray(iconOptions)) {
                        iconOptions = [iconOptions];
                    }

                    for (var i = 0; i < iconOptions.length; i++) {
                        $wrapper.append(getIconHtml(iconOptions[i]));
                    }

                    return $wrapper[0].outerHTML;

                    function getIconHtml(iconOptions) {
                        return `<i class="fal ${iconOptions.icon}  ${iconOptions.color ? iconOptions.color : 'text-primary'} ${iconOptions.cssClass}"></i>`;
                    }
                }
            },
            formatterIconBuilder: function (formatterClass, title, icon, alignment, text) {
                return `
					<div class="${getAlignmentClass(alignment)}">
                    	<a class="${formatterClass}" href="javascript:void(0)"><i class="ion ${icon}" title="${title}"></i>${(text || '')}</a>
                    </div>`;

                function getAlignmentClass(alignment) {
                    alignment = alignment || 'center';

                    const alignments = {
                        '': '', //none
                        center: 'text-center',
                        right: 'float-right',
                        left: 'float-left',
                        inline: 'd-inline-flex',
                    }

                    return alignments[alignment];
                }
            },
            deleteIconBuilder: function (formatter, alignment) {
                return grid.ui.formatterIconBuilder('delete' + formatter + ' ' + 'delete-grid-icon', _backend.text.get.delete(), 'fal fa-trash-alt', alignment);
            },
            editIconBuilder: function (formatter) {
                var formatterClass = "edit" + formatter + " edit-grid-icon";
                var title = _backend.text.get.edit();
                var icon = 'fal fa-pencil-alt';
                return grid.ui.formatterIconBuilder(formatterClass, title, icon, 'right');
            },
            formatLinkToAnchor: function (fileUrl, displayName, maxDisplayNameLength, dataAttributesArray) {
                if (!maxDisplayNameLength) {
                    maxDisplayNameLength = 100;
                }
                displayName = displayName || fileUrl;

                var formattedDisplayName = displayName;
                if (displayName.length > maxDisplayNameLength) {
                    formattedDisplayName = displayName.substring(0, maxDisplayNameLength) + '...';
                }

                return `<a href="${fileUrl}" title="${displayName}" ${getTarget(displayName, fileUrl)} ${buildSecurityAttributes(displayName)} ${_methods.data.buildDataAttributesToHtml(dataAttributesArray)}> ${formattedDisplayName} </a>`

                function buildSecurityAttributes(displayName) {
                    //if displayname is a url, then it's an external link
                    return Validator.isValidUrl(displayName) ? 'rel="noopener noreferrer"' : '';
                }

                function getTarget() {
                    return isDisplayableOnBrowser(displayName, fileUrl) ? 'target="_blank"' : '';

                    function isDisplayableOnBrowser(displayName, fileUrl) {
                        return isFileDisplayable(fileUrl) || Validator.isValidUrl(displayName);

                        function isFileDisplayable(fileUrl) {
                            fileUrl = fileUrl.toLowerCase();
                            return fileUrl.indexOf('.pdf') != -1 ||
                                fileUrl.indexOf('.jpg') != -1 ||
                                fileUrl.indexOf('.jpeg') != -1 ||
                                fileUrl.indexOf('.png') != -1 ||
                                fileUrl.indexOf('.gif') != -1 ||
                                fileUrl.indexOf('.txt') != -1;
                        }

                    }
                }
            },
            //TODO: Ought to be done automatically by a bs table init, + new table option and remove parameter hasCustomDetermineTableActionStateLogic
            initCheckboxHeaderListener: function (modelName, hasCustomDetermineTableActionStateLogic) {
                attachToEvent(modelName, 'click', 'input#' + modelName + 'checkAll', onCheckAllClick);
                attachToEvent(modelName, 'check.bs.table', '#' + modelName + 'Table', onCheck, hasCustomDetermineTableActionStateLogic);
                attachToEvent(modelName, 'uncheck.bs.table', '#' + modelName + 'Table', onUncheck, hasCustomDetermineTableActionStateLogic);
                attachToEvent(modelName, 'check-all.bs.table', '#' + modelName + 'Table', onCheckAll, hasCustomDetermineTableActionStateLogic);
                attachToEvent(modelName, 'uncheck-all.bs.table', '#' + modelName + 'Table', onUncheckAll, hasCustomDetermineTableActionStateLogic);
                attachToEvent(modelName, 'page-change.bs.table', '#' + modelName + 'Table', onPageChange, hasCustomDetermineTableActionStateLogic);
                attachToEvent(modelName, 'post-body.bs.table', '#' + modelName + 'Table', onPostBody, hasCustomDetermineTableActionStateLogic);
                attachToEvent(modelName, 'editable-init.bs.table', '#' + modelName + 'Table', onEditableInit, hasCustomDetermineTableActionStateLogic);
                //attachToEvent(modelName, 'click-cell.bs.table', '#' + modelName + 'Table', onCellClick, hasCustomDetermineTableActionStateLogic);
                //attachToEvent(modelName, 'click-row.bs.table', '#' + modelName + 'Table', onRowClick, hasCustomDetermineTableActionStateLogic);

                function attachToEvent(modelName, eventName, target, action, hasCustomDetermineTableActionStateLogic) {
                    $(document).on(eventName, target, function () {

                        action.call(this, modelName);

                        if (eventName.indexOf('.bs.table') !== -1 && typeof (hasCustomDetermineTableActionStateLogic) === 'undefined' || hasCustomDetermineTableActionStateLogic === false) {
                            _methods.grid.ui.determineConfirmTableActionButtonState(modelName + 'Table');
                        }
                    })
                }

                //function onRowClick(row,$element, field) {
                //    console.log('onRowClick', row, $element, field);
                //}

                //function onCellClick(field, value, row, $element) {
                //    console.log('cell click', field, value, row, $element);
                //}

                function onEditableInit(modelName) {
                    if (typeof (hasCustomDetermineTableActionStateLogic) === 'undefined' || hasCustomDetermineTableActionStateLogic === false) {
                        _methods.grid.ui.determineConfirmTableActionButtonState(modelName + 'Table');
                    }
                }

                function onPostBody(modelName) {
                    _methods.grid.ui.determineDisabledTableActionTextVisiblity(modelName);
                }

                function onUncheckAll(modelName) {
                    _methods.grid.ui.getRows(modelName).removeClass('selected');
                    if (typeof (hasCustomDetermineTableActionStateLogic) === 'undefined' || hasCustomDetermineTableActionStateLogic === false) {
                        _methods.grid.ui.determineConfirmTableActionButtonState(modelName + 'Table');
                    }
                }

                function onCheckAll(modelName) {
                    _methods.grid.ui.getRows(modelName).addClass('selected');
                    if (typeof (hasCustomDetermineTableActionStateLogic) === 'undefined' || hasCustomDetermineTableActionStateLogic === false) {
                        _methods.grid.ui.determineConfirmTableActionButtonState(modelName + 'Table');
                    }
                }

                function onCheck(modelName) {
                    _methods.grid.ui.determineCheckAllState(modelName);
                }

                function onUncheck(modelName) {
                    _methods.grid.ui.determineCheckAllState(modelName);
                }

                function onPageChange(modelName) {
                    $('input#' + modelName + 'checkAll').prop('indeterminate', false);
                    $('input#' + modelName + 'checkAll').prop('checked', false);
                    $('#' + modelName + 'Table tr.invalid-row').removeClass('invalid-row');
                    _methods.grid.ui.determineDisabledTableActionTextVisiblity(modelName);

                }

                //this handles the custom checkbox header that we have, on the table action
                function onCheckAllClick() {

                    var checkboxesSelector = '#' + modelName + 'Table tr input[type=checkbox]';

                    if ($(this).prop('checked') == true) {
                        $('#' + modelName + 'Table').bootstrapTable('checkAll');
                        var $enabledCheckboxes = $(checkboxesSelector + ':not(:disabled)');
                        $enabledCheckboxes.parents('tr').addClass('selected');
                        var $disabledCheckboxes = $(checkboxesSelector + ':disabled');
                        $disabledCheckboxes.parents('tr').removeClass('selected');
                    } else {
                        $('#' + modelName + 'Table').bootstrapTable('uncheckAll');
                        var $enabledCheckboxes2 = $(checkboxesSelector + ':not(:disabled)');
                        $enabledCheckboxes2.parents('tr').removeClass('selected');
                    }
                }
            },
            determineCheckAllState: function (modelName) {
                var $table = $("#" + modelName + "Table");

                if ($table.find('tbody tr:not(.no-records-found)').length == 0) {
                    setCheckAllState(modelName, 'disabled', true);
                    return;
                }

                var checkedRows = $table.bootstrapTable('getSelections');
                var checkedRowsLength = $.type(checkedRows) === 'object' ? 0 : checkedRows.length;
                var $checkboxes = _methods.grid.ui.getAllCellsInColumn(modelName, 'Checked');
                var checkboxCount = $checkboxes?.length || 0;

                //All rows are checked = check checkAll
                if (checkedRowsLength != 0 && checkedRowsLength == checkboxCount) {
                    setCheckAllState(modelName, 'indeterminate', false);
                    setCheckAllState(modelName, 'checked', true);
                    _methods.grid.ui.enableCheckAllTable(modelName);

                } else if (checkedRowsLength == 0) {
                    //No rows are checked = uncheck checkAll
                    setCheckAllState(modelName, 'indeterminate', false);
                    setCheckAllState(modelName, 'checked', false);


                    var disabledCheckboxesCount = $table.find('tbody tr:not(.no-records-found) td input[type="checkbox"]:disabled').length;
                    if (disabledCheckboxesCount > 0 && disabledCheckboxesCount == checkboxCount) {
                        //All checkboxes are disabled, checkAll should be disabled too
                        setCheckAllState(modelName, 'disabled', true);
                        //_methods.grid.ui.disableCheckAllTable(modelName); --> cant use atm, it also disables checkboxes
                    } else {
                        setCheckAllState(modelName, 'disabled', false);
                        //_methods.grid.ui.enableCheckAllTable(modelName); --> cant use atm, it also enables checkboxes
                    }
                } else {
                    setCheckAllState(modelName, 'indeterminate', true);
                    //_methods.grid.ui.enableCheckAllTable(modelName);
                }

                function setCheckAllState(modelName, property, value) {
                    var $checkAllBox = $('input#' + modelName + 'checkAll');
                    $checkAllBox.prop(property, value);
                }
            },
            uncheckAll: function (modelName) {
                var $table = $('#' + modelName + 'Table').bootstrapTable('uncheckAll');
                $table.find('tr.selected').removeClass('selected');
                _methods.grid.ui.determineCheckAllState(modelName);
            },
            setRowValidState: function ($row, isValid) {

                var invalidRowClass = 'invalid-row';
                if (isValid === true) {
                    $row.removeClass(invalidRowClass);
                } else {
                    $row.addClass(invalidRowClass);
                }

                _methods.grid.ui.determineDisabledTableActionTextVisiblity($row.parents('table').attr('id').replace('Table', ''));
            },
            getAllCellsInColumn: function (modelName, columnName) {
                var $table = $('#' + modelName + 'Table');

                //if (!$table.is(':visible')) {
                //    return;
                //}

                var columnIndex = _methods.grid.data.getEditableColumnIndexByFieldName($table, columnName);

                if (typeof columnIndex == 'undefined') {
                    return [];
                }

                return $table
                    .find('tbody tr')
                    .filter(':not(:has([colspan]))')
                    .children(':nth-child(' + (columnIndex + 1) + ')');
            },
            hideColumn: function (tableId, columnName) {
                var $table = $('#' + tableId);
                if (columnExists($table, columnName)) {
                    $table.bootstrapTable('hideColumn', columnName);
                }

                function columnExists($table, columnName) {
                    if (!Array.isArray($table.bootstrapTable('getVisibleColumns'))) {
                        return false;
                    }
                    return $table.bootstrapTable('getVisibleColumns').map(x => x.field).includes(columnName);
                }
            },
            determineDisabledTableActionTextVisiblity: function (modelName) {
                var $text = _methods.ui.getToolbar(modelName + 'Table').find('.disabled-table-action-text');
                if (_methods.grid.ui.getRows(modelName).hasClass('invalid-row') == true) {
                    $text.show();
                } else {
                    $text.hide();
                }
            },
            getRows: function (modelName) {
                var $rows = $('#' + modelName + 'Table').find('tbody tr:not(.no-records-found,:disabled)');
                var result = [];
                for (var i = 0; i < $rows.length; i++) {
                    var $row = $($rows[i]);
                    if ($row.find('input:checkbox:not(:disabled)')) {
                        result.push($rows[i]);
                    }
                }
                return $(result);
            },
        }
    };
    var notification = {
        processNotificatorMessages: function (notifications) {
            var me = this;
            if (hasValidNotifications(notifications) === false) {
                return;
            }

            $.each(notifications, function (type, notifs) { //They come grouped by Type
                type = type.toLowerCase();
                $.each(notifs, function (title) {
                    var uiNotification = {
                        title: title,
                        message: notifs[title] || "",
                        type: type
                    };
                    if (type === 'hidden') {
                        me._processHiddenNotification(uiNotification); //TODO DPH: Refactoring jsUtils. Check this.
                    } else if (
                        type === 'info' ||
                        type === 'error' ||
                        type === 'warning' ||
                        type === 'success'
                    )
                        me._showNotification(uiNotification);
                });
            });

            function hasValidNotifications(notifications) {
                if (_methods.validation.isNullOrEmptyString(notifications)) {
                    return false;
                }

                if (typeof (notifications["Hidden"]) === 'undefined' &&
                    typeof (notifications["Info"]) === 'undefined' &&
                    typeof (notifications["Error"]) === 'undefined' &&
                    typeof (notifications["Warning"]) === 'undefined' &&
                    typeof (notifications["Success"]) === 'undefined') {
                    return false;
                }

                return true;
            }
        },
        showCustomNotification: function (title, message, type, fadeOut) {
            var me = this;
            var notif = me._buildNotification("custom", title, message, type, fadeOut);
            me._showNotification(notif);
        },
        showManyNotifications: function (notificationsToShow) {
            var me = this;
            var timeout = 800;
            $.each(notificationsToShow, function (i, notif) {
                setTimeout(function () {
                    me._showNotification(notif);
                }, timeout);
                timeout += 500;
            });
        },
        showNotifyError: function (xhr) { //TODO DPH Integrate method into processNotificatorMessages?
            if (hasNotificatorNotification(xhr)) {
                //TODO DPH: N error notifications?
                var errors = xhr.responseJSON.Error;
                var notif = '';
                Object.keys(errors).forEach(function (key) {
                    notif = _methods.notification._buildNotification("ajaxErrorReponse", key, errors[key], 'danger', false);
                });

                return _methods.notification._showNotification(notif);
            }
            var errorMessage = _methods.notification._getErrorMessage(xhr);
            var n = _methods.notification._buildNotification("ajaxErrorReponse", xhr.status + ' - ' + xhr.statusText, errorMessage, 'danger', false);
            _methods.notification._showNotification(n);

            function hasNotificatorNotification(xhr) {
                return typeof (xhr.responseJSON) !== 'undefined' && typeof (xhr.responseJSON.Error) !== 'undefined';
            }
        },
        resetNotifys: function () {
            $('#notification').html('');
        },
        _buildNotification: function (id, title, message, type, fadeOut) {
            if (_methods.data.isBlankString(title)) {
                return {
                    id: id,
                    message: message,
                    type: type,
                    fadeOut: fadeOut
                };
            } else {
                return {
                    id: id,
                    title: title,
                    message: message,
                    type: type,
                    fadeOut: fadeOut
                };
            }
        },
        _getErrorMessage: function (xhr) {
            if (typeof (xhr.responseJSON) !== 'undefined' && typeof (xhr.responseJSON.message) !== 'undefined')
                return xhr.responseJSON.message;
            else if (xhr.responseText !== '' && typeof (JSON.parse(xhr.responseText).message) !== 'undefined')
                return JSON.parse(xhr.responseText).message;
            else if (typeof (xhr.responseJSON) !== 'undefined' && typeof (xhr.responseJSON.Error) !== 'undefined') {
                return xhr.responseJSON.Error;
            } else if (xhr?.responseJSON?.Notifications?.Data?.Error) {
                return xhr.responseJSON.Notifications.Data.Error[Object.keys(xhr.responseJSON.Notifications.Data.Error)[0]];
            } else {
                return '';
            }
        },
        _processHiddenNotifications: function (hiddenNotifications) {
            var me = this;
            $.each(hiddenNotifications, function (notif) {
                me._processHiddenNotification(notif);
            });
        },
        _processHiddenNotification: function (hiddenNotification) {
            $('#' + hiddenNotification.title).val(hiddenNotification.message);
        },
        _showNotification: function (notif) {
            var title = '<span style="font-weight:bold;font-size:15px;">' + notif.title + '</span><br />';
            var messageText = "";

            if (!_methods.data.isBlankString(notif.title))
                messageText += title;

            messageText += notif.message;
            messageText = messageText.replace(/(\r\n|\n|\r)/gm, "<br />");
            checkIfNotificationIsAlreadyShown(notif.id);
            $('#notification').notify({
                message: {
                    html: messageText
                }, //TODO DPH: Why html: ??
                type: determineNotificationType(),
                fadeOut: {
                    enabled: determineEnableFadeOut()
                },
            }, {
                delay: 10000
            }).show();

            function determineEnableFadeOut() {
                if (notif.type.toLowerCase() == 'success' || (typeof (notif.fadeOut) !== 'undefined' && notif.fadeOut === true))
                    return true;
                else
                    return false;
            }

            function determineNotificationType() {
                var notificationType = notif.type.toLowerCase();
                if (notificationType === 'error')
                    notificationType = 'danger';

                return notificationType;
            }

            function checkIfNotificationIsAlreadyShown(notificationId) {
                //??
            }
        },
    };

    var aceDelimiter = '';

    var search = {
        data: {
            setCallbackValuesIntoSingleAceField: function (aceId, filterIds, data, getAsString) {

                var textString = '';
                for (var j = 0; j < filterIds.length; j++) {
                    let field = _methods.data.getIdWithoutAlias(filterIds[j]); //TODO DPH: TEST!
                    if (j != 0) {
                        textString += _methods.search.data.getAceDelimiter();
                    }

                    var value = data[field];

                    if (typeof (value) === 'undefined') {
                        textString += '';
                    }
                    else {
                        value = replaceInvalidAndDangerousCharactersForRequest(value);
                        if (value.toString().indexOf('/Date(') !== -1) {
                            var jsonDate = new Date(parseInt(value.substr(6)));
                            value = moment(jsonDate).locale(_methods.data.getBootstrapDatepickerLanguage()).format('L')//$.datepicker.formatDate("DD.MM.YY 00:00:00", jsonDate);
                        }
                        textString += value;
                    }
                }
                var $el = $('#' + aceId);
                //$el.data = data;

                if (getAsString == true) {
                    return textString;
                }

                if ($el.is('input')) {
                    $el.typeahead('val', textString);
                } else {
                    $el.val(textString);
                }

                function replaceInvalidAndDangerousCharactersForRequest(sourceString) {
                    sourceString = replaceWhile(_methods.search.data.getAceDelimiter(), sourceString); //is interpreted by ace as an extra parameter in the query
                    sourceString = replaceWhile('<', sourceString); //is considered as a potential XSS attack
                    sourceString = replaceWhile('>', sourceString); //is considered as a potential XSS attack

                    return sourceString;

                    function replaceWhile(characterToReplace, sourceString) {
                        var wildcardCharacter = '*';
                        sourceString = "".concat(sourceString);
                        while (sourceString.toString().indexOf(characterToReplace) !== -1) {
                            sourceString = sourceString.replace(characterToReplace, wildcardCharacter);
                        }

                        return sourceString;
                    }
                }
            },
            setAceDelimiter: function (delimiter) {
                aceDelimiter = "".concat(delimiter.trim()); //casts the delimiter to string
            },
            getAceDelimiter: function () {
                if (aceDelimiter === '') {
                    return ','; //default is comma, but it can be customized with an xpgpara
                }

                return decodeURIComponent(aceDelimiter);
            }
        },
        events: {
            subscribeToSearchPanelCompletedInit(aceSelector, options, modelName) {
                PubSub.subscribe('sph/' + 'init-complete/' + modelName, function initAce() {
                    $(aceSelector).autocomplete(options).attr('placeholder', options.tooltipText);
                });
            }
        }
    };
    var tab = {
        disableAllTabsExcept: function (tabId) {
            var t = $('#tabs');
            var indexesOfTabsToDisable = [];
            var activeTabIndex;

            $("#tabs ul li[role='tab']").each(function (index) {
                var currentId = $(this).attr('id');
                if (currentId != tabId)
                    indexesOfTabsToDisable.push(index);
                else
                    activeTabIndex = index;
            });
            t.tabs({
                disabled: indexesOfTabsToDisable
            });
            t.tabs('option', 'active', activeTabIndex);
        },
        enableAllTabs: function () {
            //Die Tabs div muss tabs als id haben.
            $("#tabs").tabs({
                disabled: []
            }); //TODO DPH: Refactoring jsUtils. Check this.
        },
        isTabActive: function (tabId) {
            return $('#tabs ul li#' + tabId + '[role="tab"]').hasClass('ui-tabs-active');
        },
        setTabActive: function (tabId) { //TODO DPH: Refactoring jsUtils. Check this.
            var t = $('#tabs');
            $("#tabs ul li[role='tab']").each(function (index) {
                var $tab = $(this);
                var currentId = $(this).attr('id');
                if (currentId == tabId) {
                    $tab.removeClass('ui-state-disabled');
                    t.tabs('option', 'active', index);
                    $(window).trigger('scroll');
                }
            });
        },
    };
    var ui = {
        accordion: {
            disableSinglePanel: function (ariaControlsId) {
                $('h3[aria-controls="' + ariaControlsId + '"]').addClass('ui-state-disabled');
            },
            enableSinglePanel: function (ariaControlsId) {
                $('h3[aria-controls="' + ariaControlsId + '"]').removeClass('ui-state-disabled');
            },
            $getActiveAccordionContainer: function (accordionId) {
                return $($('#' + accordionId + ' .accordion-container')[$('#' + accordionId).accordion('option', 'active')]);
            }
        },
        addTooltip: function (selector, text) {
            var $el = $(selector);
            $el.tooltip('dispose');
            $el.tooltip({
                title: text,
                container: 'body'
            });

        },
        disableAllInputsInContainer: function (containerId) { //Not used
            $('#' + containerId + ' :input').attr('disabled', true);
        },
        disableButton: function (buttonId) {
            $('button#' + buttonId).attr('disabled', true);
        },
        //more aptly named : disableElement
        disableCheckbox: function (selector) {
            var $checkbox = $(selector);
            $checkbox.prop('disabled', true);
            $checkbox.attr('disabled', true);
        },
        disableConfirmTableActionButton: function (tableId) {
            var $button = this.getTableActionButton(tableId);
            $button.attr('disabled', true);
            $button.tooltip('hide');
        },

        enableAllInputsInContainer: function (containerId) { //Not used
            $('#' + containerId + ' :input').attr('disabled', false);
        },
        enableButton: function (buttonId) {
            $('button#' + buttonId).attr('disabled', false);
        },
        enableCheckbox: function (selector) {
            var $checkbox = $(selector);
            $checkbox.prop('disabled', false);
            $checkbox.attr('disabled', false);
        },
        enableConfirmTableActionButton: function (tableId) {
            var $button = this.getTableActionButton(tableId);
            $button.attr('disabled', false);
        },
        getTableActionButton: function (tableId) {
            var $toolbar = this.getToolbar(tableId);
            var $button = $toolbar.find('.bs-bars.float-left button');

            if ($button.length === 0) {
                $button = $toolbar.find('.fixed-table-toolbar').find('button.table-action-container');
            }

            return $button;
        },
        getToolbar: function (tableId) {
            return $('#' + tableId).closest('.bootstrap-table').find('.fixed-table-toolbar');
        },
        initSelect2: function (select2Selector, options, type) {

            let timeoutId = setTimeout(function () {
                if (!$.fn.select2) {
                    return;
                }
                var ops = initOptions(select2Selector, options);

                initBase(select2Selector, ops);
                if (type === 'multi' && options.hasAllOption === true) {
                    attachMultiSelectListeners(select2Selector, ops);
                }

                timeoutId = null;

                function initBase(select2Selector, ops) {
                    var $el = $(select2Selector);
                    $el.select2(ops);

                    $el.on('select2:unselecting', function () {
                        var opts = $(this).data('select2').options;
                        opts.set('disabled', true);
                        setTimeout(function () {
                            opts.set('disabled', false);
                        }, 1);
                    });

                    if (ops.closeOnSelect == false) {
                        attachUnselectedWorkaroundListeners($el);
                    }

                    function attachUnselectedWorkaroundListeners($el) {
                        //These two listeners prevent the dropdown from opening when clicking the X to clear a selection
                        $el.on('select2:opening', function (e) {
                            if ($(this).data('unselecting')) {
                                $(this).removeData('unselecting');
                                if (!$(this).data('isOpen')) {
                                    e.preventDefault();
                                }
                            }
                        }).on('select2:unselecting', function (e) {
                            $(this).data({
                                unselecting: true,
                                isOpen: $(this).data('select2').isOpen()
                            });
                        });
                    }
                }
                function initOptions(select2Selector, options) {
                    var lang = _methods.data.getCultureInfo().Name.split('-')[0];
                    var closeOnSelect = $(select2Selector).attr('multiple') ? false : true;
                    var select2Options = {
                        theme: "bootstrap",
                        language: lang,
                        width: options ? options.width || '100%' : '100%',
                        closeOnSelect: closeOnSelect,
                        dropdownAutoWidth: true,
                        allowClear: options ? options.allowClear : false,
                        placeholder: options ? options.placeholder || '' : '', //allowClear throws an exception if there is no placeholder
                    };

                    if (typeof (options) != 'undefined' && typeof (options.disabled) != 'undefined') {
                        select2Options['disabled'] = options.disabled;
                    }

                    if (typeof (options) != 'undefined' && typeof (options.templateSelection) != 'undefined') {
                        select2Options['templateSelection'] = options.templateSelection;
                    }

                    return select2Options;
                }

                function attachMultiSelectListeners(select2Selector, ops) {

                    var $dropdown = $(select2Selector);


                    $dropdown
                        .on('select2:select', function (e) {
                            var data = e.params.data;
                            var $option = $(data.element);
                            if (data.id == 0) {
                                //deselect and disable all others
                                var liefOpts = getOtherOptGroupOptions($option);
                                liefOpts.prop('selected', false);;
                                liefOpts.attr('disabled', true);
                            } else {
                                var alleOpt = getOtherOptGroupOptions($option);
                                alleOpt.prop('selected', false);;
                                alleOpt.attr('disabled', true);
                            }

                            initBase(select2Selector, ops);

                            function getOtherOptGroupOptions($option) {
                                return $option.parents('optgroup').siblings().find('option');
                            }

                        }).on('select2:unselect', function (e) {
                            var $dropdown = $(this);
                            var count = $(this).siblings('span.select2').find('ul li').length - 1;
                            if (count == 0) {
                                $dropdown.find('option').prop('disabled', false);
                                setTimeout(function () {
                                    initBase(select2Selector, ops);
                                }, 300);
                            }
                        });
                }
            }, 0);



        },

        progressBar: {
            reset: function (progressBarSelector) {
                var $progressBar = $(progressBarSelector);

                if ($progressBar.length == 0) {
                    return;
                }

                _methods.ui.progressBar.removeClassesByPattern(progressBarSelector);
                $progressBar.text('');
                $progressBar.css('width', 0);
                $progressBar.attr('aria-valuenow', 0);
            },
            setProgress: function (progressBarSelector, progress) {
                var $progressBar = $(progressBarSelector);
                $progressBar.attr('aria-valuenow', progress);
                $progressBar.css('width', Math.round(progress) + "%");
                determineProgressBarColorClass($progressBar, progress, progressBarSelector);

                function determineProgressBarColorClass($pb, progress, progressBarSelector) {
                    _methods.ui.progressBar.removeClassesByPattern(progressBarSelector);
                    if (progress <= 50) {
                        $pb.addClass('progress-bar-danger');
                    } else if (progress >= 50 && progress < 75) {
                        $pb.addClass('progress-bar-warning');
                    } else if (progress >= 75) {
                        $pb.addClass('progress-bar-success');
                    }
                }
            },
            removeClassesByPattern: function (progressBarSelector, optionalPattern) {
                //TODO DPH: This method should be generally available, not nust for progress bars
                var pattern = '\\progress-bar-';
                var selector = '#ProgressBar';
                if (progressBarSelector) {
                    selector = progressBarSelector;
                }

                if (optionalPattern) {
                    pattern = optionalPattern;
                }

                _methods.ui.removeClassesByPattern(selector, pattern);
            },

        },
        removeClassesByPattern: function (selector, pattern) {
            if (_methods.validation.isNullOrEmptyString(selector) || _methods.validation.isNullOrEmptyString(pattern)) {
                alert('removeClassesByPattern');
            }

            var classes = _methods.ui.getClassesByPattern(selector, pattern);
            var $element = $(selector);

            for (var i = 0; i < classes.length; i++) {
                $element.removeClass(clasess[i]);
            }
        },
        getClassesByPattern: function (selector, pattern) {
            var byPattern = [];
            var allClasses = $(selector).attr("class").split(/\s+/);
            var r = new RegExp(pattern + "\\S+", ['g']);
            for (var i = 0; i < allClasses; i++) {
                var cssClass = allClasses[i];
                if (cssClass.match(r) == true) {
                    byPattern.push(cssClass);
                }
            }

            return byPattern;

        },
        addLoadingOverLay: function (contentParentSelector) {
            if (!contentParentSelector) {
                contentParentSelector = '#content'; // Entire content (right of the menu) of the page
            }

            var $container = $(contentParentSelector);
            if ($container.find('.loading-overlay').length === 0) {
                $container.addClass('overlay-container');
                $container.prepend('<div class="loading-overlay"><i class="fa fa-refresh fa-spin"></i></div>');
            }
        },
        removeLoadingOverlay: function (contentParentSelector) {
            if (!contentParentSelector) {
                contentParentSelector = '#content'; // Entire content (right of the menu) of the page
            }

            var $container = $(contentParentSelector);
            $container.removeClass('overlay-container');
            $container.find('.loading-overlay').remove();
        },
        generateBadge: function (count) {
            if (!count) {
                return;
            }

            return ' <span class="badge badge-light">' + count + '</span>';

        },
    };
    var validation = {
        isNullOrEmptyString: function (str) {
            return !str || /^\s*$/.test(str);
        },
        isCheckbox: function ($el) {
            return $el.attr('type') === 'checkbox';
        },
        isDatepicker: function ($el) {
            return $el.hasClass('datepicker');
        },
        isInteger: function (value) {
            return (typeof value === 'number') && (value % 1 === 0);
        },
        getDoubleValidationMessage: function (value) {
            var pattern = _methods.data.getFloatPatternForInput();
            var regExpFloatPattern = new RegExp(pattern, 'g');
            //is value cultured?
            var precision = _methods.data.getMandantNumberPrecision();
            if (regExpFloatPattern.test(value) == true) {
                return true;
            }

            if (exceedsAllowedDecimalDigits(value, precision) == true) {
                return _backend.text.get.tooManyDecimalPlaces() + ' ' + precision;
            } else {
                return getDefaultValidationMessage(precision);
            }

            function getDefaultValidationMessage(precision) {
                var message = _backend.text.get.pleaseMatchTheRequestedFormat();

                var decimalSeparator = _methods.data.getCultureInfo().DecimalSeparator;
                var decimalDigitsPlaceholder = getPlaceholders(precision);
                var friendlyPattern = ' ' + '###' + decimalSeparator + decimalDigitsPlaceholder;

                return message + friendlyPattern;

                function getPlaceholders(count) {
                    var placeholder = '';
                    for (var i = 0; i < count; i++) {
                        placeholder += '#';
                    }
                    return placeholder;
                }
            }

            function exceedsAllowedDecimalDigits(value) {

                var decimalSeparator = _methods.data.getCultureInfo().DecimalSeparator;
                var decimalStartIndex = value.indexOf(decimalSeparator);

                if (decimalStartIndex === -1) {
                    return false;
                }

                var decimalDigits = value.substr(decimalStartIndex + 1, value.length).length;

                return decimalDigits > precision;
            }
        }
    };
    var url = {
        clearUrlParameters: function () {
            // get the string following the ?
            var query = window.location.search.substring(1);

            // is there anything there ?
            if (query.length) {
                // are the new history methods available ?
                if (window.history != undefined && window.history.pushState != undefined) {
                    // if pushstate exists, add a new state the the history, this changes the url without reloading the page

                    window.history.pushState({}, document.title, window.location.pathname);
                }
            }
        },
        getQueryStringParam: function (sParam) {
            var result = [];
            var pageUrl = window.location.search.substring(1);
            var urlVariables = pageUrl.split('&');
            for (var i = 0; i < urlVariables.length; i++) {
                var sParameterName = urlVariables[i].split('=');
                if (sParameterName[0].toLowerCase() == sParam.toLowerCase()) {
                    result.push(sParameterName[1]);
                }
            }
            return result;
        }
    };

    //TODO DPH: Refactor other usages of AjaxOptions to use this one
    var AjaxOptions = function (type, url, data, callbacks) {
        /* DPH TODO: COPY PASTE from BestellungPositionAb.js */

        this.options = {
            type: type ? type : undefined,
            url: url ? url : undefined,
            data: data ? JSON.stringify(data) : undefined,
        };
        this.callbacks = {
            done: callbacks?.done ? callbacks.done : undefined,
            fail: callbacks?.fail ? callbacks.fail : undefined,
        };
    };

    var ajax = {
        request: function (type, url, data, callbacks) {
            var options = new AjaxOptions(type, url, data, callbacks);
            return ajaxRequest(options);

            function ajaxRequest(ajaxOptions) {
                var baseOptions = getBaseOptions();
                var opts = $.extend({}, baseOptions, ajaxOptions.options);

                return $.ajax(opts)
                    .done(function (xhr) {
                        if (typeof (ajaxOptions.callbacks.done) !== 'undefined') {
                            ajaxOptions.callbacks.done(xhr);
                        }

                        _methods.notification.processNotificatorMessages(xhr);
                    }).fail(function (xhr) {
                        if (typeof (ajaxOptions.callbacks.fail) !== 'undefined') {
                            ajaxOptions.callbacks.fail(xhr);
                        }

                        _methods.notification.showNotifyError(xhr);
                    });

                function getBaseOptions() {
                    return {
                        'contentType': 'application/json; charset=utf-8',
                        'dataType': 'json',
                    };
                }
            }
        }
    };

    var internalMethods =
    {
        grid: {
            ui: {
                addButtonToToolbar: function (addType, buttonSelector, tableId, optionalTooltipText) {
                    var rightToolbarSelector = '.columns.columns-right.btn-group.float-right';
                    if (hasButtonAlreadyBeenAppended(buttonSelector, rightToolbarSelector) == true) {
                        return;
                    }

                    var $button = $(buttonSelector);
                    var $toolbar = $('table#' + tableId).parents('.bootstrap-table').find(rightToolbarSelector);
                    if (addType == 'prepend') {
                        $toolbar.prepend($button);
                    } else {
                        //append
                        $toolbar.append($button);
                    }

                    if (_methods.validation.isNullOrEmptyString(optionalTooltipText) == false) {
                        _methods.ui.addTooltip(buttonSelector, optionalTooltipText);
                    }
                    $button.show();

                    function hasButtonAlreadyBeenAppended(buttonSelector, rightToolbarSelector) {
                        return $(rightToolbarSelector).find(buttonSelector).length > 0;
                    }
                },
            },
        },
    };

    //Alphabetically sorted
    var _methods = {
        ajax: ajax,
        bootstrapDialog: bootstrapDialog,
        data: data,
        form: form,
        grid: grid,
        notification: notification,
        search: search,
        tab: tab,
        ui: ui,
        url: url,
        validation: validation,
        _backend: _backend,
    };
    return _methods;
})($);

export default jsUtils;